import React, { ReactElement } from 'react'
import { ReviewUserStepProps } from '../ReviewUserData'
import UserCompletedItem from '../components/Item'
import UserCompletedList from '../components/List'
import UserCompletedSectionHeader from '../components/SectionHeader'
import configStore from '../../../../../../stores/config.store'

const ReviewWallet = ({
  user,
  parentUrl,
  readonly = false
}: ReviewUserStepProps): ReactElement => {
  if (!user?.wallet) return <></>

  const { wallet } = user
  return (
    <>
      <UserCompletedSectionHeader
        title="Wallet Check"
        path={`${parentUrl}/wallet`}
        readonly={readonly}
      />
      <UserCompletedList>
        {configStore.config?.verificationStepsConfig?.wallet
          ?.receivingWallet ? (
          <>
            <UserCompletedItem header="Sending Wallet Protocol">
              {wallet.walletProtocol}
            </UserCompletedItem>
            <UserCompletedItem header="Sending Wallet Address">
              {wallet.walletAddress}
            </UserCompletedItem>
            <UserCompletedItem header="Receiving Wallet Protocol" newLine>
              {wallet.receivingWalletProtocol}
            </UserCompletedItem>
            <UserCompletedItem header="Receiving Wallet Address">
              {wallet.receivingWalletAddress}
            </UserCompletedItem>
          </>
        ) : (
          <UserCompletedItem header="Address">
            {wallet.walletAddress}
          </UserCompletedItem>
        )}
      </UserCompletedList>
    </>
  )
}

export default ReviewWallet
